export default __webpack_public_path__ + "static/media/grafema_armazem-da-alfandega_05.97d3cae7.jpg";